/** Client-safe membership tier labels (no server/db imports) */

export type MembershipTierCode = "NONE" | "SILVER" | "GOLD";

export const MEMBERSHIP_TIER_META: Record<
  MembershipTierCode,
  {
    label: string;
    title: string;
    description: string;
    badgeClass: string;
    cardClass: string;
  }
> = {
  NONE: {
    label: "ທົ່ວໄປ",
    title: "ສະມາຊິກທົ່ວໄປ",
    description: "ສະສົມແຕ້ມຈາກ scan — ຍັງບໍ່ມີບັດ Silver/Gold",
    badgeClass: "bg-muted text-muted-foreground border-border",
    cardClass: "border-border/70 bg-muted/20",
  },
  SILVER: {
    label: "ບັດເງິນ",
    title: "ບັດເງິນ (Silver)",
    description: "ແກ້ວຟຣີຕໍ່ຮອບ + ສ່ວນຫຼຸດ tier ຕາມການຕັ້ງຄ່າ",
    badgeClass:
      "bg-slate-200/80 text-slate-900 border-slate-300 dark:bg-slate-700/50 dark:text-slate-100",
    cardClass:
      "border-slate-300/80 bg-gradient-to-br from-slate-100/80 to-muted/30 dark:from-slate-900/40 dark:to-muted/20",
  },
  GOLD: {
    label: "ບັດຄຳ",
    title: "ບັດຄຳ (Gold)",
    description: "ແກ້ວຟຣີສູງສຸດ + ຊິມເມນູໃໝ່ + ສ່ວນຫຼຸດ tier ສູງສຸດ",
    badgeClass:
      "bg-amber-200/90 text-amber-950 border-amber-400/60 dark:bg-amber-900/40 dark:text-amber-100",
    cardClass:
      "border-amber-400/50 bg-gradient-to-br from-amber-100/70 to-muted/30 dark:from-amber-950/30 dark:to-muted/20",
  },
};

export const MEMBERSHIP_SOURCE_LABELS: Record<
  "AUTO_SCAN" | "ADMIN" | "PURCHASE",
  string
> = {
  AUTO_SCAN: "ຂຶ້ນອັດຕະໂນມັດຈາກ scan",
  ADMIN: "ແອດມິນຕັ້ງ tier ມື",
  PURCHASE: "ຊື້ບັດ (ອນາຄິດ)",
};
